import { usePathname } from 'expo-router';
import { useEffect, useRef } from 'react';
import { useMixpanel } from '../lib/mixpanel';

const ROUTE_TO_SCREEN: Record<string, string> = {
  '/': 'Home',
  '/dashboard': 'Dashboard',
  '/leads': 'Leads',
  '/funnel': 'Pipeline',
  '/analytics': 'Analytics',
  '/ai-agent': 'AI Agent',
  '/chat': 'Chat',
  '/voice-agents': 'Voice Agents',
  '/workflows': 'Workflows',
  '/campaigns': 'Campaigns',
  '/linkedin-search': 'LinkedIn Search',
  '/settings': 'Settings',
  '/mission-control': 'Mission Control',
  '/login': 'Login',
  '/signup': 'Signup',
  '/landing': 'Landing',
  '/lead/new': 'New Lead',
};

function resolveScreenName(pathname: string): string {
  if (ROUTE_TO_SCREEN[pathname]) return ROUTE_TO_SCREEN[pathname];

  const leadMatch = /^\/lead\/(.+)$/.exec(pathname);
  if (leadMatch) return 'Lead Detail';

  return pathname;
}

export function useScreenTracking() {
  const pathname = usePathname();
  const mp = useMixpanel();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    if (pathname && pathname !== previousPath.current) {
      previousPath.current = pathname;
      mp.screen(resolveScreenName(pathname), { path: pathname });
    }
  }, [pathname, mp]);
}
